import React from "react";
import Slider from "react-slick";
import "./Slider.css";
import "./Slider-theme.css";







function SimpleSlider({teams}) {
  const settings = {
    dots: false,
    autoplaySpeed: 6000,
    autoplay: true,
    infinite: true,
    speed: 700,
    lazyLoad: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div >
      <Slider {...settings}>
        {
          teams.map((info, index) => (
            <div key={index} className=" bg-bgColor-100 w-full h-96">
              <div className=" text-slate-500" >
                <div className="">
                  <img className=" w-full h-full object-contain obje object-buttom" src={info.bgImg} alt="slide pic" />
                </div>
              </div>
            </div>
          ))
        }
        
      </Slider>
    
    </div>
  );
}

export default SimpleSlider;